import {
  Injectable
} from '@angular/core';
import {
  HttpClient
} from '@angular/common/http';
import {
  PayPeriodDTO,
  ClientDTO,
  StaffDTO,
  TimeSheet,
  Description,
  TimeSummaryRow,
  Category,
  PTO,
  StaffCodeDTO
} from 'src/store/workspace';
import {
  Observable
} from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) {}

  getPayPeriods = (): Observable<PayPeriodDTO[]> => {
    return this.http.get(`${environment.apiUrl}/PayPeriods`) as Observable<PayPeriodDTO[]>;
  }
  getClients = (): Observable<ClientDTO[]> => {
    return this.http.get(`${environment.apiUrl}/clients`) as Observable<ClientDTO[]>;
  }

  getStaffByUser = (): Observable<StaffDTO> => {
    return this.http.get(`${environment.apiUrl}/Staff/GetStaffByUser`) as Observable<StaffDTO>;
  }

  getStaff = (): Observable<StaffDTO[]> => {
    return this.http.get(`${environment.apiUrl}/Staff`) as Observable<StaffDTO[]>;
  }

  getStaffCodes = (): Observable<StaffCodeDTO[]> => {
    return this.http.get(`${environment.apiUrl}/Staff/StaffCodes`) as Observable<StaffCodeDTO[]>;
  }

  getTimeSheets = (body: GetTimeSheetsRequest): Observable <any> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingDetail/TimeTrackingDetailFiltered`, body);
  }

  getCategories = (): Observable<Category[]> => {
    return this.http.get(`${environment.apiUrl}/clientBillCategories`) as Observable<Category[]>;
  }

  addCategory = ({category, clientID}): Observable<Category> => {
    return this.http.post(`${environment.apiUrl}/clientBillCategories/addClientBillCategory`, {category, clientID}) as Observable<Category>;
  }

  addDescription = ({categoryID, description, clientID}): Observable<Description> => {
    return this.http.post(
      `${environment.apiUrl}/ClientBillDescriptions/AddClientBillDescription`,
      {categoryID, description, active: true, clientID}
    ) as Observable<Description>;
  }

  saveTimesheet = (body: TimeSheet): Observable<any> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingDetail/UpdateTimeTrackingDetail`, body);
  }
  addTimesheet = (body: TimeSheet): Observable<any> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingDetail/AddTimeTrackingDetail`, body);
  }

  deleteTimesheet = (timeTrackingDetailIdx: string): Observable<any> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingDetail/DeleteTimeTrackingDetail`, {}, {params: {timeTrackingDetailIdx}});
  }

  getDescriptions = (isAdmin: boolean): Observable<Description[]> => {
    return this.http.get(`${environment.apiUrl}/ClientBillDescriptions/ClientBillDescriptionsFiltered`,
    {params: {activeFlag: isAdmin ? '2' : '1'}}) as Observable <Description[]>;
  }

  updateDescription = (description: Description): any => {
    return this.http.post(`${environment.apiUrl}/ClientBillDescriptions/UpdateClientBillDescription`, description);
  }

  getSummary = (body: SummaryRequest): Observable<TimeSummaryRow[]> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingSummary/TimeTrackingSummaryFiltered`, body) as Observable<TimeSummaryRow[]>;
  }

  getUnsubmittedSummary = (body: UnsubmittedSummaryRequest): Observable<TimeSummaryRow[]> => {
    // tslint:disable-next-line: max-line-length
    return this.http.post(`${environment.apiUrl}/vwTimeTrackingSummary/vwTimeTrackingSummaryFiltered`, body) as Observable<TimeSummaryRow[]>;
  }

  submitSummaryRow = (body: SubmitSummaryRowRequest): Observable<TimeSummaryRow[]> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingSummary/AddUpdateTimeTrackingSummary`, body) as Observable<TimeSummaryRow[]>;
  }

  undoSummaryRow = (body: {timeSummaryIdx: number}): Observable<TimeSummaryRow[]> => {
    return this.http.post(`${environment.apiUrl}/TimeTrackingSummary/UndoSubmitSummaryRow`, body) as Observable<TimeSummaryRow[]>;
  }

  getPaidTimeOff = (body: PTORequest): Observable<PTO> => {
    return this.http.post(`${environment.apiUrl}/PTO/PTOFiltered`, body) as Observable<PTO>;
  }

  addClient = (body: ClientDTO) => {
    return this.http.post(`${environment.apiUrl}/clients/AddClient`, body)
  }

  deleteClient = (body: ClientDTO) => {
    return this.http.post(`${environment.apiUrl}/clients/DeleteClient`, body)
  }

  updateClient = (body: ClientDTO) => {
    return this.http.post(`${environment.apiUrl}/clients/UpdateClient`, body)
  }

  addStaff = (body: StaffDTO) => {
    return this.http.post(`${environment.apiUrl}/Staff/AddStaff`, body)
  }

  deleteStaff = (body: StaffDTO) => {
    return this.http.post(`${environment.apiUrl}/Staff/DeleteStaff`, body)
  }

  updateStaff = (body: StaffDTO) => {
    return this.http.post(`${environment.apiUrl}/Staff/UpdateStaff`, body)
  }

}

export interface GetTimeSheetsRequest {
    StaffID: number;
    ClientID?: number;
    StartDateWorked: string;
    EndDateWorked: string;
}

export interface SummaryRequest {
  staffID: number;
  clientID: number;
  PayPeriodStartDate: string;
  PayPeriodEndDate: string;
  submittedFlag: number;
}

export interface UnsubmittedSummaryRequest {
  staffID: number;
  clientID: number;
  PayPeriodStarting: string;
  PayPeriodEnding: string;
  submittedFlag: 0;
}

export interface SubmitSummaryRowRequest {
  staffID: number;
  clientID: number;
  PayPeriodStarting: string;
  PayPeriodEnding: string;
  submittedDate: string;
  totalHoursBillable: number;
}

export interface UndoSummaryRowRequest {
  timeSummaryIdx: number;
}

export interface PTORequest {
  staffID: number;
  year: number;
}